"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slider = void 0;
var React = require("react");
exports.slider = function (props) {
    var renderImages = function (images, lazy) {
        var renderImage = function (image, index) {
            var attr = !lazy && !index ? { src: image.path } : { 'custom-img': image.path };
            return (React.createElement("div", { key: index, className: "c-slider__cell c-slider__cell--img" },
                React.createElement("img", __assign({}, attr, { alt: image.caption }))));
        };
        return images.map(function (it, index) {
            return renderImage(it, index);
        });
    };
    var renderEmptyImages = function (props) {
        var renderEmptyElement = function (index, props) {
            return (React.createElement("div", { key: index, className: "c-slider__cell c-slider__cell--empty" },
                React.createElement("span", { className: "c-slider__cell-text" }, props.nameNoPhoto)));
        };
        var elements = [];
        for (var i = 0; i < 2 - props.images.length; i = i + 1) {
            elements.push(renderEmptyElement(i, props));
        }
        return elements;
    };
    var renderArrowsNext = function () { return (React.createElement("div", { className: "c-slider__control c-slider__control--next" },
        React.createElement("span", { className: "fal fa-chevron-right" }))); };
    var renderArrowsPrev = function () { return (React.createElement("div", { className: "c-slider__control c-slider__control--prev" },
        React.createElement("span", { className: "fal fa-chevron-left" }))); };
    return (React.createElement("div", { className: "c-slider" },
        props.images.length > 1 ? renderArrowsNext() : '',
        props.images.length > 1 ? renderArrowsPrev() : '',
        React.createElement("div", { className: "c-slider__touchable" },
            React.createElement("div", { className: "c-slider__flim" },
                renderImages(props.images, props.lazy),
                renderEmptyImages(props)))));
};
